import { render, staticRenderFns } from "./PackageSingle.vue?vue&type=template&id=1c373aae&scoped=true"
import script from "./PackageSingle.vue?vue&type=script&lang=js"
export * from "./PackageSingle.vue?vue&type=script&lang=js"
import style0 from "./PackageSingle.vue?vue&type=style&index=0&id=1c373aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c373aae",
  null
  
)

export default component.exports